import { styled } from 'styled-components';
import React from 'react';
import { InfoIconTooltip } from '../../../components/icons/InfoIconTooltip';

/**
 * Component to display a description for an entity list.
 * It preserves line breaks and limits the width for better readability.
 */
export const EntityListDescription = styled.div`
  white-space: pre-line; // Preserve line breaks
  max-width: 60rem; // Limit the width for better readability on wide screens
  margin-bottom: 0;
`;

interface EntityListDescriptionInfoIconTooltip {
  description?: string;
  style?: React.CSSProperties;
}

export const EntityListDescriptionInfoIconTooltip: React.FC<
  EntityListDescriptionInfoIconTooltip
> = ({ description, style }) => (
  <InfoIconTooltip
    content={<EntityListDescription>{description}</EntityListDescription>}
    style={style}
  />
);
